
export const formatBytes = (bytes: number, decimals = 2): string => {
  if (!+bytes) {

    return "0 Bytes";
  }

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};


export const getBgColor = (value: number, warning: number, critical: number): string | undefined => {

  if (value >= critical) {
    return "#d50000";
  }

  return value >= warning ? "#ff6d00" : undefined;
};

